module.exports = {
	"dailyData": [
		{
			"width": "120",
			"label": "日期",
			"prop": "date"
		},
		{
			"width": "",
			"label": "开闭环",
			"prop": "isOpen"
		},
		{
			"width": "",
			"label": "来源",
			"prop": "data_source"
		},
		{
			"width": "180",
			"label": "账号",
			"prop": "account"
		},
		{
			"width": "",
			"label": "用户名",
			"prop": "userName"
		},
		{
			"width": "100",
			"label": "Avg.SG",
			"prop": "avgSG"
		},
		{
			"width": "100",
			"label": "SGnum",
			"prop": "SGnum"
		},
		{
			"width": "100",
			"label": "< 3.0",
			"prop": "below30Percent"
		},
		{
			"width": "",
			"label": "TBR",
			"prop": "TBRPercent"
		},
		{
			"width": "",
			"label": "TIR",
			"prop": "TirPercent"
		},
		{
			"width": "",
			"label": "TAR",
			"prop": "tarPercent"
		},
		{
			"width": "100",
			"label": "> 13.9",
			"prop": "beyond13Percent"
		},
		{
			"width": "100",
			"label": "Auto%",
			"prop": "AutoPercent"
		},
		{
			"width": "",
			"label": "Basal",
			"prop": "avgBasal"
		},
		{
			"width": "100",
			"label": "Basal%",
			"prop": "basalPercent"
		},
		{
			"width": "",
			"label": "Bolus",
			"prop": "avgBolus"
		},
		{
			"width": "100",
			"label": "Bolus%",
			"prop": "bolusPercent"
		},
		{
			"width": "",
			"label": "TDD",
			"prop": "TDD"
		},
		{
			"width": "",
			"label": "(TDD/Avg.TDD)%",
			"prop": "TDDPercent"
		},
		{
			"width": "",
			"label": "Umax",
			"prop": "umax"
		},
		{
			"width": "120",
			"label": "Newbasal",
			"prop": "newbasal"
		}
	],
	"accountData": [
		{
			"width": "70",
			"label": "组别",
			"prop": "groupName"
		},
		{
			"width": "",
			"label": "开闭环",
			"prop": "isOpen"
		},
		{
			"width": "180",
			"label": "账号",
			"prop": "account"
		},
		{
			"width": "",
			"label": "来源",
			"prop": "data_source"
		},
		{
			"width": "",
			"label": "用户名",
			"prop": "userName"
		},
		{
			"width": "100",
			"label": "Avg.SG",
			"prop": "avgSG"
		},
		{
			"width": "100",
			"label": "SGnum",
			"prop": "SGnum"
		},
		{
			"width": "",
			"label": "< 3.0",
			"prop": "below30Percent"
		},
		{
			"width": "",
			"label": "TBR",
			"prop": "TBRPercent"
		},
		{
			"width": "",
			"label": "TIR",
			"prop": "TirPercent"
		},
		{
			"width": "",
			"label": "TAR",
			"prop": "tarPercent"
		},
		{
			"width": "100",
			"label": "> 13.9",
			"prop": "beyond13Percent"
		},
		{
			"width": "100",
			"label": "Auto%",
			"prop": "AutoPercent"
		},
		{
			"width": "",
			"label": "Basal",
			"prop": "avgBasal"
		},
		{
			"width": "100",
			"label": "Basal%",
			"prop": "basalPercent"
		},
		{
			"width": "",
			"label": "Bolus",
			"prop": "avgBolus"
		},
		{
			"width": "100",
			"label": "Bolus%",
			"prop": "bolusPercent"
		},
		{
			"width": "",
			"label": "TDD",
			"prop": "TDD"
		},
		{
			"width": "",
			"label": "Umax",
			"prop": "umax"
		},
		{
			"width": "120",
			"label": "Newbasal",
			"prop": "newbasal"
		}
	],
	"invalidAccountData": [
		{
			"label": "账号",
			"prop": "accountName"
		},
		{
			"width": "",
			"label": "用户名",
			"prop": "userName"
		}
	],
	"groupData": [
		{
			"width": "70",
			"label": "组别",
			"prop": "groupName"
		},
		{
			"width": "",
			"label": "Avg.SG",
			"prop": "avgSG"
		},
		{
			"width": "",
			"label": "SGnum",
			"prop": "SGnum"
		},
		{
			"width": "",
			"label": "< 3.0",
			"prop": "below30Percent"
		},
		{
			"width": "",
			"label": "TBR",
			"prop": "TBRPercent"
		},
		{
			"width": "",
			"label": "TIR",
			"prop": "TirPercent"
		},
		{
			"width": "",
			"label": "TAR",
			"prop": "tarPercent"
		},
		{
			"width": "",
			"label": "> 13.9",
			"prop": "beyond13Percent"
		},
		{
			"width": "",
			"label": "Auto%",
			"prop": "AutoPercent"
		},
		{
			"width": "",
			"label": "Basal",
			"prop": "avgBasal"
		},
		{
			"width": "",
			"label": "Basal%",
			"prop": "basalPercent"
		},
		{
			"width": "",
			"label": "Bolus",
			"prop": "avgBolus"
		},
		{
			"width": "",
			"label": "Bolus%",
			"prop": "bolusPercent"
		}
	],
	"insulinData": [
		{
			"width": "120",
			"label": "日期",
			"prop": "date"
		},
		{
			"width": "180",
			"label": "账号",
			"prop": "account"
		},
		{
			"width": "",
			"label": "用户名",
			"prop": "userName"
		},
		{
			"width": "",
			"label": "来源",
			"prop": "data_source"
		},
		{
			"width": "",
			"label": "Basal",
			"prop": "totalBasal"
		},
		{
			"width": "",
			"label": "Bolus",
			"prop": "totalBolus"
		},
		{
			"width": "",
			"label": "0:00-1:00",
			"prop": "basalDate1",
			"child": [
				{
					"width": "",
					"label": "Basal1",
					"prop": "Basal1"
				}
			]
		},
		{
			"width": "",
			"label": "1:00-2:00",
			"prop": "basalDate2",
			"child": [
				{
					"width": "",
					"label": "Basal2",
					"prop": "Basal2"
				}
			]
		},
		{
			"width": "",
			"label": "2:00-3:00",
			"prop": "basalDate3",
			"child": [
				{
					"width": "",
					"label": "Basal3",
					"prop": "Basal3"
				}
			]
		},
		{
			"width": "",
			"label": "3:00-4:00",
			"prop": "basalDate4",
			"child": [
				{
					"width": "",
					"label": "Basal4",
					"prop": "Basal4"
				}
			]
		},
		{
			"width": "",
			"label": "4:00-5:00",
			"prop": "basalDate5",
			"child": [
				{
					"width": "",
					"label": "Basal5",
					"prop": "Basal5"
				}
			]
		},
		{
			"width": "",
			"label": "5:00-6:00",
			"prop": "basalDate6",
			"child": [
				{
					"width": "",
					"label": "Basal6",
					"prop": "Basal6"
				}
			]
		},
		{
			"width": "",
			"label": "6:00-7:00",
			"prop": "basalDate7",
			"child": [
				{
					"width": "",
					"label": "Basal7",
					"prop": "Basal7"
				}
			]
		},
		{
			"width": "",
			"label": "7:00-8:00",
			"prop": "basalDate8",
			"child": [
				{
					"width": "",
					"label": "Basal8",
					"prop": "Basal8"
				}
			]
		},
		{
			"width": "",
			"label": "8:00-9:00",
			"prop": "basalDate9",
			"child": [
				{
					"width": "",
					"label": "Basal9",
					"prop": "Basal9"
				}
			]
		},
		{
			"width": "",
			"label": "9:00-10:00",
			"prop": "basalDate10",
			"child": [
				{
					"width": "",
					"label": "Basal10",
					"prop": "Basal10"
				}
			]
		},
		{
			"width": "",
			"label": "10:00-11:00",
			"prop": "basalDate11",
			"child": [
				{
					"width": "",
					"label": "Basal11",
					"prop": "Basal11"
				}
			]
		},
		{
			"width": "",
			"label": "11:00-12:00",
			"prop": "basalDate12",
			"child": [
				{
					"width": "",
					"label": "Basal12",
					"prop": "Basal12"
				}
			]
		},
		{
			"width": "",
			"label": "12:00-13:00",
			"prop": "basalDate13",
			"child": [
				{
					"width": "",
					"label": "Basal13",
					"prop": "Basal13"
				}
			]
		},
		{
			"width": "",
			"label": "13:00-14:00",
			"prop": "basalDate14",
			"child": [
				{
					"width": "",
					"label": "Basal14",
					"prop": "Basal14"
				}
			]
		},
		{
			"width": "",
			"label": "14:00-15:00",
			"prop": "basalDate15",
			"child": [
				{
					"width": "",
					"label": "Basal15",
					"prop": "Basal15"
				}
			]
		},
		{
			"width": "",
			"label": "15:00-16:00",
			"prop": "basalDate16",
			"child": [
				{
					"width": "",
					"label": "Basal16",
					"prop": "Basal16"
				}
			]
		},
		{
			"width": "",
			"label": "16:00-17:00",
			"prop": "basalDate17",
			"child": [
				{
					"width": "",
					"label": "Basal17",
					"prop": "Basal17"
				}
			]
		},
		{
			"width": "",
			"label": "17:00-18:00",
			"prop": "basalDate18",
			"child": [
				{
					"width": "",
					"label": "Basal18",
					"prop": "Basal18"
				}
			]
		},
		{
			"width": "",
			"label": "18:00-19:00",
			"prop": "basalDate19",
			"child": [
				{
					"width": "",
					"label": "Basal19",
					"prop": "Basal19"
				}
			]
		},
		{
			"width": "",
			"label": "19:00-20:00",
			"prop": "basalDate20",
			"child": [
				{
					"width": "",
					"label": "Basal20",
					"prop": "Basal20"
				}
			]
		},
		{
			"width": "",
			"label": "20:00-21:00",
			"prop": "basalDate21",
			"child": [
				{
					"width": "",
					"label": "Basal21",
					"prop": "Basal21"
				}
			]
		},
		{
			"width": "",
			"label": "21:00-22:00",
			"prop": "basalDate22",
			"child": [
				{
					"width": "",
					"label": "Basal22",
					"prop": "Basal22"
				}
			]
		},
		{
			"width": "",
			"label": "22:00-23:00",
			"prop": "basalDate23",
			"child": [
				{
					"width": "",
					"label": "Basal23",
					"prop": "Basal23"
				}
			]
		},
		{
			"width": "",
			"label": "23:00-24:00",
			"prop": "basalDate24",
			"child": [
				{
					"width": "",
					"label": "Basal24",
					"prop": "Basal24"
				}
			]
		},
		{
			"width": "",
			"label": "0:00-1:00",
			"prop": "bolusDate1",
			"child": [
				{
					"width": "",
					"label": "Bolus1",
					"prop": "Bolus1"
				}
			]
		},
		{
			"width": "",
			"label": "1:00-2:00",
			"prop": "bolusDate2",
			"child": [
				{
					"width": "",
					"label": "Bolus2",
					"prop": "Bolus2"
				}
			]
		},
		{
			"width": "",
			"label": "2:00-3:00",
			"prop": "bolusDate3",
			"child": [
				{
					"width": "",
					"label": "Bolus3",
					"prop": "Bolus3"
				}
			]
		},
		{
			"width": "",
			"label": "3:00-4:00",
			"prop": "bolusDate4",
			"child": [
				{
					"width": "",
					"label": "Bolus4",
					"prop": "Bolus4"
				}
			]
		},
		{
			"width": "",
			"label": "4:00-5:00",
			"prop": "bolusDate5",
			"child": [
				{
					"width": "",
					"label": "Bolus5",
					"prop": "Bolus5"
				}
			]
		},
		{
			"width": "",
			"label": "5:00-6:00",
			"prop": "bolusDate6",
			"child": [
				{
					"width": "",
					"label": "Bolus6",
					"prop": "Bolus6"
				}
			]
		},
		{
			"width": "",
			"label": "6:00-7:00",
			"prop": "bolusDate7",
			"child": [
				{
					"width": "",
					"label": "Bolus7",
					"prop": "Bolus7"
				}
			]
		},
		{
			"width": "",
			"label": "7:00-8:00",
			"prop": "bolusDate8",
			"child": [
				{
					"width": "",
					"label": "Bolus8",
					"prop": "Bolus8"
				}
			]
		},
		{
			"width": "",
			"label": "8:00-9:00",
			"prop": "bolusDate9",
			"child": [
				{
					"width": "",
					"label": "Bolus9",
					"prop": "Bolus9"
				}
			]
		},
		{
			"width": "",
			"label": "9:00-10:00",
			"prop": "bolusDate10",
			"child": [
				{
					"width": "",
					"label": "Bolus10",
					"prop": "Bolus10"
				}
			]
		},
		{
			"width": "",
			"label": "10:00-11:00",
			"prop": "bolusDate11",
			"child": [
				{
					"width": "",
					"label": "Bolus11",
					"prop": "Bolus11"
				}
			]
		},
		{
			"width": "",
			"label": "11:00-12:00",
			"prop": "bolusDate12",
			"child": [
				{
					"width": "",
					"label": "Bolus12",
					"prop": "Bolus12"
				}
			]
		},
		{
			"width": "",
			"label": "12:00-13:00",
			"prop": "bolusDate13",
			"child": [
				{
					"width": "",
					"label": "Bolus13",
					"prop": "Bolus13"
				}
			]
		},
		{
			"width": "",
			"label": "13:00-14:00",
			"prop": "bolusDate14",
			"child": [
				{
					"width": "",
					"label": "Bolus14",
					"prop": "Bolus14"
				}
			]
		},
		{
			"width": "",
			"label": "14:00-15:00",
			"prop": "bolusDate15",
			"child": [
				{
					"width": "",
					"label": "Bolus15",
					"prop": "Bolus15"
				}
			]
		},
		{
			"width": "",
			"label": "15:00-16:00",
			"prop": "bolusDate16",
			"child": [
				{
					"width": "",
					"label": "Bolus16",
					"prop": "Bolus16"
				}
			]
		},
		{
			"width": "",
			"label": "16:00-17:00",
			"prop": "bolusDate17",
			"child": [
				{
					"width": "",
					"label": "Bolus17",
					"prop": "Bolus17"
				}
			]
		},
		{
			"width": "",
			"label": "17:00-18:00",
			"prop": "bolusDate18",
			"child": [
				{
					"width": "",
					"label": "Bolus18",
					"prop": "Bolus18"
				}
			]
		},
		{
			"width": "",
			"label": "18:00-19:00",
			"prop": "bolusDate19",
			"child": [
				{
					"width": "",
					"label": "Bolus19",
					"prop": "Bolus19"
				}
			]
		},
		{
			"width": "",
			"label": "19:00-20:00",
			"prop": "bolusDate20",
			"child": [
				{
					"width": "",
					"label": "Bolus20",
					"prop": "Bolus20"
				}
			]
		},
		{
			"width": "",
			"label": "20:00-21:00",
			"prop": "bolusDate21",
			"child": [
				{
					"width": "",
					"label": "Bolus21",
					"prop": "Bolus21"
				}
			]
		},
		{
			"width": "",
			"label": "21:00-22:00",
			"prop": "bolusDate22",
			"child": [
				{
					"width": "",
					"label": "Bolus22",
					"prop": "Bolus22"
				}
			]
		},
		{
			"width": "",
			"label": "22:00-23:00",
			"prop": "bolusDate23",
			"child": [
				{
					"width": "",
					"label": "Bolus23",
					"prop": "Bolus23"
				}
			]
		},
		{
			"width": "",
			"label": "23:00-24:00",
			"prop": "bolusDate24",
			"child": [
				{
					"width": "",
					"label": "Bolus24",
					"prop": "Bolus24"
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountAdmin/dataSTS/dataStatisticsTaableHeader.json
// module id = 543
// module chunks = 7